export const CompaniesData = [
  {
    companiesID: 1,
    companiesName: 'Naudotos Audi detalės',
    companiesLocation: 'Vilnius',
    companiesAddress: 'Naujamiestis, Dzūkų gatvė 7',
    companiesEmail: 'audiDet@gmail.com',
    companiesPhone: '+3704567891235',
    partsNumber: '1234',
    registerDate: '2020.10.11'
  },
  {
    companiesID: 2,
    companiesName: 'BMW šrotas',
    companiesLocation: 'Kaunas',
    companiesAddress: 'Domeikava, Algirdo gatvė 4',
    companiesEmail: 'bmwsrotas@gmail.com',
    companiesPhone: '+370987456321',
    partsNumber: '9631',
    registerDate: '2021.2.19'
  },
  {
    companiesID: 3,
    companiesName: 'Petro laužynas',
    companiesLocation: 'Šiauliai',
    companiesAddress: 'Dainiai, Respublikos gatvė 47',
    companiesEmail: 'petroslauzynas@gmail.com',
    companiesPhone: '+37045999637',
    partsNumber: '16245',
    registerDate: '2021.6.5'
  }
];
